import { createPinia } from 'pinia'
import { createApp } from 'vue'

import { LDialogPlugin, LNotificationPlugin } from '@last/core-ui/paprika'

import App from './App.vue'
import i18n from './i18n'
import router from './router'

import './devCode'
import './style.css'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)

app.use(LNotificationPlugin)
app.use(LDialogPlugin)
app.use(router)
app.use(i18n)

app.mount('#app')
